import { get } from "lodash";

export const shouldShowNoiDefinition = loan => Boolean(get(loan, "covenants.noiDefinition"));

export const shouldShowDebtServiceDefinition = loan => Boolean(get(loan, "covenants.debtServiceDefinition"));

export const shouldShowDebtYieldDefinition = loan => Boolean(get(loan, "covenants.debtYieldDefinition"));

export const shouldShowDscrDefinition = loan => Boolean(get(loan, "covenants.dscrDefinition"));

export const shouldShowLtvDefinition = loan => Boolean(get(loan, "covenants.ltvDefinition"));

export const shouldShowDefinitionsMisc = loan => Boolean(get(loan, "covenants.definitionsMisc"));
